import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito comprar ropa nueva para aplicarlo?',
    a: 'No. El 90% del sistema funciona con las prendas que ya tienes en tu closet.'
  }, {
    q: '¿Sirve si vivo en un clima muy caluroso?',
    a: 'Sí. Incluimos técnicas específicas para aplicar el sistema de capas con telas livianas en climas cálidos.'
  }, {
    q: '¿Funciona si soy muy bajita?',
    a: 'Sí. Hay una sección completa dedicada a alargar la silueta petit con proporciones específicas.'
  }, {
    q: '¿Es un libro físico que me envían?',
    a: 'Es un PDF digital. Acceso inmediato después del pago. Sin esperas, sin envíos.'
  }, {
    q: '¿Funciona para todos los tipos de cuerpo?',
    a: 'Sí. El sistema está diseñado para cuerpos reales con curvas, abdomen, cadera y brazos. No para maniquíes de pasarela.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes 7 días de garantía total. Te devolvemos el dinero sin preguntas.'
  }];
  return <section className="bg-brand-bg py-12 sm:py-16 px-4" data-id="element-35">
      <div className="max-w-content mx-auto" data-id="element-36">
        <FadeIn data-id="element-37">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-text mb-10" data-id="element-38">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-40">
              <div className="bg-white border border-brand-text/10 rounded-xl overflow-hidden shadow-sm transition-all duration-300" data-id="element-41">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-42">
                  <span className="font-bold text-brand-text pr-4" data-id="element-43">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-accent transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-44" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-45">
                  <p className="text-brand-text/80 leading-relaxed" data-id="element-46">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}